define('viewModels/privileged/composer/forms/formEditor/ReadOnlyTextBlockQuestion',[
    'lib/lodash4',
    'lib/knockout',
    'viewModels/privileged/composer/forms/formEditor/BaseQuestion',
    'viewModels/privileged/composer/vmUtils',
    'viewModels/privileged/composer/EntitySubviewMixinProvider',
    'viewModels/privileged/composer/VisibilityConditionMixinProvider'
], function (
    _,
    ko,
    BaseQuestionViewModel,
    utils,
    EntitySubviewMixinProvider,
    VisibilityConditionMixinProvider
) {
    'use strict';

    var ReadOnlyTextQuestionViewModel = BaseQuestionViewModel.extend(function readOnlyTextVM_init(questionModel, namesList, formEditorState, questionMap) {
        var self = this;

        self.canEnableVisibilityCondition = self.computed(function () {
            return self.getQuestionOptions().length > 0;
        });

        var visibilityConditionMixinProvider = new VisibilityConditionMixinProvider(self);
        visibilityConditionMixinProvider.addVisibilityConditions(questionMap, questionModel, self.getQuestionOptions, formEditorState);

        // Survey form question types can never be critical or kill, or have comments
        self.isCritical = ko.observable(false);
        self.criticalEnabled = ko.observable(false);
        self.isKill = ko.observable(false);
        self.failedKillQuestion = ko.observable(false);
        self.comments = ko.observable(null);

        // No response required for this type, so it can't be marked NA
        self.isNaEnabled = ko.observable(false);


        // Override base hasStatus behavior to include visibility conditions
        var baseHasStatus = self.hasStatus;
        self.hasStatus = self.computed(function () {
            return baseHasStatus() || self.visibilityConditionEnabled();
        });

        // Resets the question to initial unanswered state
        var baseClearResponse = self.clearResponse;
        self.clearResponse = function () {
            baseClearResponse();
        };

        // Get the answers in a form that quality can use them.  Transform attribute names
        // Do NOT call any superclass methods - each subclass is in control of how it wants to return data
        self.getQualityAnswerData = function() {
            return {
                questionId: questionModel.id,
                markedNA: false,
                comments: null
            };
        };

        var baseFillQualityAnswerData = self.fillQualityAnswerData;
        self.fillQualityAnswerData = function(qualityQuestionAnswerData) {
            if (qualityQuestionAnswerData) {
                baseFillQualityAnswerData(qualityQuestionAnswerData);
            }

            self.comments(null);
        };

        self.subscribe(self.visibilityConditionVisible, function (isVisible) {
            if (!isVisible) {
                self.clearResponse();
            }
        });

    }, true); //flag indicates that the model should be passed to the parent constructor

    return ReadOnlyTextQuestionViewModel;
});

